var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgT1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "13px",
    height: "24px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -234 -22 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.2502836621904785 24  L 3.2502836621904785 10.796524881868265  L 0 10.796524881868265  L 0 5.498551856004715  L 3.2502836621904785 5.498551856004715  L 3.2502836621904785 0  L 9.74971633780952 0  L 9.74971633780952 5.498551856004715  L 13 5.498551856004715  L 13 10.796524881868265  L 9.74971633780952 10.796524881868265  L 9.74971633780952 24  L 3.2502836621904785 24  Z ",
    fillRule: "nonzero",
    fill: "#2eb557",
    stroke: "none",
    transform: "matrix(1 0 0 1 234 22 )"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgT1);
export default __webpack_public_path__ + "static/media/t1.48d91e2d6ed9238c2213753701c5eed9.svg";
export { ForwardRef as ReactComponent };